import React, { useMemo } from 'react'
import { IntlProvider } from 'react-intl'
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl'
import initLocalization, { Localization } from 'lib/localization'
import { useAppSelector } from 'redux/toolkit/hooks'
import KENDO_EN from 'config/i18n/kendo_en.json'
import KENDO_ES from 'config/i18n/kendo_es.json'

const LocalizationProviderFix: any = LocalizationProvider

loadMessages(KENDO_EN, 'en')
loadMessages(KENDO_ES, 'es')

export const IntlWrapper = ({ children }: React.PropsWithChildren) => {
  const { language } = useAppSelector(_store => ({
    language: _store.app.language
  }))
  const localization: Localization = useMemo(() => initLocalization(language), [language])

  return (
    <IntlProvider locale={localization.locale} messages={localization.messages}>
      <LocalizationProviderFix language={localization.locale.substring(0, 2)}>{children}</LocalizationProviderFix>
    </IntlProvider>
  )
}
